// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getPlatformUsersIndex: ({commit, state}, params) => request.alert('getPlatformUsersIndex', params),
  getPlatformUsersDetail: ({commit, state}, params) => request.alert('getPlatformUsersDetail', params),
  addPlatformUser: ({commit, state}, params) => request.alert('addPlatformUser', params),
  editPlatformUser: ({commit, state}, params) => request.alert('editPlatformUser', params),
  deletePlatformUser: ({commit, state}, params) => request.alert('deletePlatformUser', params),
  copyPlatformUser: ({commit, state}, params) => request.alert('copyPlatformUser', params),

  getAllCustomers: ({commit, state}, params) => request.alert('getAllCustomers', params),
  getAdminOptions: ({commit, state}, params) => request.alert('getAdminOptions', params),
}

// mutations
const mutations = {}

export const platformUser = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/platform-user/platform-user.store.js